import ApiService from "@/services/api.service";

const api = new ApiService();

class MacroApi {
  public async all() {
    return await api.get(`/macros/all`);
  }
}

export default new MacroApi();
